import { render, staticRenderFns } from "./GoogleDriveSelector.vue?vue&type=template&id=3f4d968f"
import script from "./GoogleDriveSelector.vue?vue&type=script&lang=ts"
export * from "./GoogleDriveSelector.vue?vue&type=script&lang=ts"
import style0 from "./GoogleDriveSelector.vue?vue&type=style&index=0&id=3f4d968f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports